export * from "../global/qr-code";
